module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c5_r1#d6e5"
    }
  }, [_vm._v("CHAPTER 3 "), _c('br'), _c('br'), _vm._v(" A Perfect Storm")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e371839"
    }
  }, [_c('i', [_vm._v("When [Chesterton’s] religion was at its lowest point, in the difficult Art School days, he never lost it entirely. “I hung on to religion,” [he later said,] “by one thin thread of thanks.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d97",
      "id": "a97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e373639"
    }
  }, [_c('i', [_vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AISIE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARD")]), _vm._v(" (1943)")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e374139"
    }
  }, [_c('span', {
    staticClass: "dcap2",
    attrs: {
      "id": "d14e1081"
    }
  }, [_vm._v("M")]), _vm._v("uch as the JDC meant to Chesterton—and it meant all the world to him at this time of his life—he knew that his involvement with the group was bound to change. For by autumn 1892, he had left St. Paul’s School to begin taking art classes at the Slade School of Art and, a bit later in 1893, courses in Latin and English literature at University College, London. The others in JDC could go on together for a while yet, as they, being younger than Chesterton, would not go up to university until the autumn of 1894.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e377839"
    }
  }, [_vm._v("One would have thought this would be an exciting time for Chesterton. He’d been drawing all his life and would now be able to immerse himself fully in the visual arts. He could develop his gift.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e378939"
    }
  }, [_vm._v("Yet it was at the Slade School that he experienced a period of desolation unlike any he would ever know. It was his dark night of the soul.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e380740"
    }
  }, [_vm._v("Two developments seemed to have triggered this. In choosing to go to the Slade School, Chesterton was at an unwelcome distance from virtually all of his friends in the JDC. He and Edmund Bentley maintained a steady correspondence, but this could not begin to compensate for all that the JDC had meant when they were all together at St. Paul’s."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d98",
      "id": "a98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" For a time, he still continued to send contributions to the "), _c('i', [_vm._v("Debater")]), _vm._v(", but the last of these efforts was a poem written in late 1892 or early 1893."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d99",
      "id": "a99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e384340"
    }
  }, [_vm._v("Second, Chesterton was away from his family more than he ever had been before. Whatever their eccentricities were, it was a loving home. His mother indulged him, while his father was proud, supportive, and entertaining. And then, of course, his brother, Cecil, had always been a good friend. They rather constantly wrangled, but beneath the arguments and youthful competitiveness lay a very close bond."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d100",
      "id": "a100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t02140"
    }
  }, [_vm._v(" Suddenly, all of these sources of support (the most important in his life) were gone, or greatly diminished. In their place was a school where he knew few people—and where for the first time he was exposed to “current trends in art”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d101",
      "id": "a101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v("—in particular the cultural pessimism and decadence so closely associated with London in the 1890s. As scholar George P. Landow wrote, the assumptions underlying much of the poetry, fiction, and art of this time centered on “an anti-Romantic belief in original sin and in fallen man and nature; the omnipresence of evil and the grotesque”; as well as a “lack of health, balance, and innocence.” The mood and tone of this period was a marked pervasive cultural atmosphere of “ennui, incompleteness, a sense of loss, exile and isolation.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d102",
      "id": "a102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t02240"
    }
  }, [_vm._v(" Portions of Chesterton’s dedicatory poem to Edmund Bentley for the novel "), _c('i', [_vm._v("The Man Who Was Thursday")]), _vm._v(" form his most powerful recollection of this time of decadence and how it affected him:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e394241"
    }
  }, [_c('i', [_vm._v("A cloud was on the minds of men, and wailing went the weather,")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d9t02341"
    }
  }, [_c('i', [_vm._v("Yea, a sick cloud upon the soul when we were boys together."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d103",
      "id": "a103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e395741"
    }
  }, [_vm._v("Further on in the poem, Chesterton spoke of “doubts that drove us through the night” and the decadents themselves, who “twisted even decent sin to shapes not to be named.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d104",
      "id": "a104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t02441"
    }
  }, [_vm._v(" For a sensitive young man whose sense of how things are was being altered with alarming speed, all of these factors combined to form a perfect storm. He was unready for all the changes, and Landow’s words above could have been applied with equal justice to Chesterton’s feelings. It was he who felt overwhelmed by “a sense of loss, exile and isolation.” Decades later, writing in his "), _c('i', [_vm._v("Autobiography")]), _vm._v(", he could still remember it vividly:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e400041"
    }
  }, [_vm._v("There is something truly menacing in the thought of how quickly I could imagine the maddest, when I had never committed the mildest crime . . . there was a time when I had reached that condition of moral anarchy within, in which a man says, in the words of Wilde, that “Atys with the blood-stained knife were better than the thing I am.” I have never indeed felt the faintest temptation to the particular madness of Wilde, but I could at this time imagine the worst and wildest disproportions and distortions of more normal passion; the point is that the whole mood was overpowered and oppressed with a sort of congestion of imagination. As Bunyan, in his morbid period, described himself as prompted to utter blasphemies, I had an overpowering impulse to record or draw horrible ideas and images; plunging deeper and deeper as in a blind spiritual suicide."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d105",
      "id": "a105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e405942"
    }
  }, [_vm._v("At this time, Chesterton had begun to fill a notebook with “these horrible drawings.” One day two of his friends discovered it. Shocked by what they saw, they asked each other, “Is Chesterton going mad?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d106",
      "id": "a106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t02542"
    }
  }, [_vm._v("To make matters worse, Chesterton was also dabbling in the occult. He“used the planchette freely” and began to experience strange headaches. After them “came a horrid feeling as if one were trying to get over a bad spree, with what I can best describe as a bad smell in the mind.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d107",
      "id": "a107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Wherever he turned, it seemed, he was confronted with things that were alien, strange, and unsettling. All this inner turmoil was unfolding amidst a cultural moment that was itself unsettled. Frederick Buechner has described Chesterton’s dilemma in this way:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e410942"
    }
  }, [_vm._v("The decadence and darkness that horrified him in himself were also all around him in those last few years of the nineteenth century. The beliefs and values that mid-Victorian England had looked upon as eternal were giving place to doubt, skepticism, a loss of inner balance, and all that Matthew Arnold could hear of the faith of his fathers was “its melancholy, long, withdrawing roar.” Schopenhauer was in vogue, with his grim philosophy that life was nothing more than an illusory, malignant affair that inveigles humankind into reproducing in order to perpetuate it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d108",
      "id": "a108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e414442"
    }
  }, [_vm._v("Chesterton himself later summed it all up in one sentence: “I did not very clearly distinguish between dreaming and waking; not only as a mood but as a metaphysical doubt.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d109",
      "id": "a109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" He was in the midst of an existential crisis.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e416442"
    }
  }, [_vm._v("How Chesterton began to struggle free of his despair was something he could not have predicted. Traditional means of sorting things out were largely absent from his life. Neither he nor his parents were particularly religious. He was, therefore, left to his own devices. It was then that something he perhaps only half understood began to fasten itself upon his thoughts. As he later recalled:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e419243"
    }
  }, [_vm._v("When I had been for some time in these, the darkest depths of the contemporary pessimism, I had a strong inward impulse to revolt; to dislodge this incubus or throw off this nightmare. But as I was still thinking the thing out by myself, with little help from philosophy and no real help from religion, I invented a rudimentary and makeshift mystical theory of my own."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d110",
      "id": "a110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e421943"
    }
  }, [_vm._v("What was this mystical theory? For Chesterton it centered on notions of existence and nothingness. The contrast between them had begun to spur his thinking. And the more he thought about it, the more he began to see something clearly. “Mere existence,” he wrote,")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e423343"
    }
  }, [_vm._v("reduced to its most primary limits, was extraordinary enough to be exciting. Anything was magnificent as compared with nothing. Even if the very daylight were a dream, it was a day-dream; it was not a nightmare. The mere fact that one could wave one’s arms and legs about . . . showed that it had not the mere paralysis of a nightmare. Or if it was a nightmare, it was an enjoyable nightmare. In fact, I had wandered to a position not very far from the phrase of my Puritan grandfather, when he said that he would thank God for his creation if he were a lost soul. I hung on to the remains of religion by one thin thread of thanks. I [had discovered a] way of looking at things, with a sort of mystical minimum of gratitude."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d111",
      "id": "a111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e427943"
    }
  }, [_vm._v("In this discovery, Chesterton was aided and abetted by writers who would forever remain among his favorites. He was indebted to them not only as artists but also because they had not heeded the pessimistic spirit of the age. “I was assisted,” Chesterton wrote,")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e429844"
    }
  }, [_vm._v("by those few of the fashionable writers who were not pessimists; especially by Walt Whitman, by Browning and by Stevenson; Browning’s “God must be glad one loves his world so much,” or Stevenson’s “belief in the ultimate decency of things.” But I do not think it is too much to say that I took it in a way of my own; even if it was a way I could not see clearly or make very clear. What I meant, whether or no I managed to say it, was this; that no man knows how much he is an optimist, even when he calls himself a pessimist, because he has not really measured the depths of his debt to whatever created him and enabled him to call himself anything. At the back of our brains, so to speak, there was a forgotten blaze or burst of astonishment at our own existence. The object of the artistic and spiritual life was to dig for this submerged sunrise of wonder; so that a man sitting in a chair might suddenly understand that he was actually alive, and be happy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d112",
      "id": "a112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e435444"
    }
  }, [_vm._v("It was this realization, this discovery of the mystical minimum, that restored life and sanity to Chesterton. As Buechner has written, Chesterton “was filled with both an enormous sense of thankfulness, and an enormous need for someone or something to thank, which he expressed in a number of the random pieces that [began to appear in his] notebook.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d113",
      "id": "a113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" But this notebook, started in the autumn of 1894,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d114",
      "id": "a114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" was a wholly different repository of his thoughts from the book that had earlier been filled with the morbid and macabre. Chesterton rendered his own thoughts in verse:")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e440545"
    }
  }, [_c('i', [_vm._v("Here dies another day")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e440845"
    }
  }, [_c('i', [_vm._v("During which I have had eyes, ears, hands")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e441145"
    }
  }, [_c('i', [_vm._v("And the great world round me;")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e441445"
    }
  }, [_c('i', [_vm._v("And with tomorrow begins another.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e441945"
    }
  }, [_c('i', [_vm._v("Why am I allowed two?"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d115",
      "id": "a115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e442945"
    }
  }, [_vm._v("Slowly, at his own pace, Chesterton was moving down the road to faith. Grace entered his vocabulary in a wholly new light, and verse seemed the most fitting way to express what he felt:")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e444245"
    }
  }, [_c('i', [_vm._v("You say grace before meals")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e444545"
    }
  }, [_c('i', [_vm._v("All right.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e445045"
    }
  }, [_c('i', [_vm._v("But I say grace before the play and the opera,")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e445345"
    }
  }, [_c('i', [_vm._v("And grace before the concert and pantomime,")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e445645"
    }
  }, [_c('i', [_vm._v("And grace before I open a book,")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e446045"
    }
  }, [_c('i', [_vm._v("And grace before sketching, painting,")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e446345"
    }
  }, [_c('i', [_vm._v("Swimming, fencing, boxing, walking, playing, dancing;")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e446645"
    }
  }, [_c('i', [_vm._v("And grace before I dip the pen in the ink."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d116",
      "id": "a116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e447545"
    }
  }, [_vm._v("Soon, Chesterton’s thoughts began to take a turn reminiscent of Pascal’s "), _c('i', [_vm._v("Pensées")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d117",
      "id": "a117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Persistent questions were now the things that lay close to heart. “Have you ever known,” he wrote, “what it is to walk along a road in such a frame of mind that you thought you might meet God at any turn of the path?” He framed the answer to that question in a lovely meditation called “The Prayer of a Man Resting”:")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e450745"
    }
  }, [_c('i', [_vm._v("The twilight closes round me")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e451045"
    }
  }, [_c('i', [_vm._v("My head is bowed before the Universe")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e451345"
    }
  }, [_c('i', [_vm._v("I thank thee, O Lord, for a child I knew seven years ago")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e451645"
    }
  }, [_c('i', [_vm._v("And whom I have never seen since.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e452746"
    }
  }, [_c('i', [_vm._v("Praised be God for all sides of life, for friends, lovers, art, literature, knowledge, humour, politics, and for the little red cloud away there in the west—"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d118",
      "id": "a118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e454246"
    }
  }, [_vm._v("Biographer Maisie Ward, the wife of his publisher Frank Ward, read through Chesterton’s notebook and gave these glimpses of grace to the world. She summarized the transformation of this time in his life as well as anyone ever has. At school, she wrote, Chesterton was looking for God, but “at the age of 16 he was, he tells us in "), _c('i', [_vm._v("Orthodoxy")]), _vm._v(", an Agnostic in the sense of one who is not sure one way or the other. Largely it was this need for gratitude for what seemed personal gifts that brought him to belief in a personal God. Life was personal, it was not a mere drift; it had will in it, it was more like a story.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d119",
      "id": "a119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t02646"
    }
  }, [_vm._v(" By the summer of 1894, Chesterton understood that he was caught up in that story. And he had begun to know its Author."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Kevi_9781595553836_epub_c36_r1#d120",
      "id": "a120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e619b66e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kevi_9781595553836_epub_c10_r1.vue
// module id = 87
// module chunks = 0